import React, { useState, useCallback, useEffect } from 'react'
import { Row, Col, Skeleton, DatePicker, Pagination } from 'antd'

import Table from './Table'

import './index.less'
import _ from 'lodash'
import moment from 'moment'
import locale from 'antd/lib/date-picker/locale/ru_RU'
import { getOTPStat } from '../../../api/different'

moment.locale('ru')

const { RangePicker } = DatePicker;

const OTPStat = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [dateRange, setDateRange] = useState([
    moment().add(-1, 'M'),
    moment(),
  ])

  useEffect(() => {

    if (dateRange.length === 2) {
      setLoading(true)

    const payload = {
      dateBegin: dateRange[0].format('YYYY-MM-DD'),
      dateEnd: dateRange[1].format('YYYY-MM-DD')
    }

    getOTPStat(payload)
      .then((res) => {
        const {result} = res
        
        let totalCnt = 0
        let totalAmount = 0
        let totalSuccessCnt = 0
        let totalPrice = 0
        let totalApproveCnt = 0
        let totalApproveSuccessCnt = 0
        let totalCustomersCnt = 0
        let totalApproveFailedCnt = 0
        let totalApproveFailedPercent = 0
        
        result.forEach(({ n_cnt, n_amount, n_error_cnt, n_success_cnt, cnt_approve_success, cnt_approve_all, cnt_customers_all, n_approve_failed, n_approve_failed_percent, n_price }) => {
          totalCnt += parseInt(n_cnt)
          totalAmount += parseFloat(n_amount)
          totalSuccessCnt += parseInt(n_success_cnt)
          totalApproveCnt += parseInt(cnt_approve_all)
          totalApproveSuccessCnt += parseInt(cnt_approve_success)
          totalCustomersCnt += parseInt(cnt_customers_all)
          totalApproveFailedCnt += parseInt(n_approve_failed)
          totalApproveFailedPercent += parseFloat(n_approve_failed_percent) / result.length
          totalPrice = n_price > totalPrice ? n_price : totalPrice
        });

        setData([...result, {
          key: "0",
          idnum: "",
          s_sellers: "Итого",
          n_cnt: totalCnt,
          n_success_cnt: totalSuccessCnt,
          cnt_approve_success: totalApproveSuccessCnt,
          cnt_approve_all: totalApproveCnt,
          cnt_customers_all: totalCustomersCnt,
          n_approve_failed: totalApproveFailedCnt,
          n_approve_failed_percent: totalApproveFailedPercent,
          n_price: totalPrice,
          n_amount: totalAmount,
          is_footer: true
        }])
        setLoading(false)
      })
      .catch((res) => {
        console.log(res)
        console.log('Error')
        setLoading(false)
      })
    }
  }, [dateRange])

  const onChangeRange = (e,_) => {
    setDateRange(e)
  };
  
  return (
    <div>
      {!loading ?
        <React.Fragment>
          <Row type='flex' justify='start' gutter={[16, 24]}>
            <Col>
              <RangePicker 
                locale={locale}
                defaultValue={dateRange}
                onChange={onChangeRange} 
              />
            </Col>
          </Row>
          <Row type='flex' justify='start' gutter={[16, 24]}>
            <Col>
              <Table
                loading={loading}
                dataSource={data}
                scroll={{ x: '100%' }}
                size="middle"
              />
            </Col>
          </Row>
        </React.Fragment>
      :
        <Skeleton active />}
    </div>
  )
}

export default OTPStat



// WEBPACK FOOTER //
// src/containers/Dashboard/OTPStat/index.jsx